import provinciasFile from './provincias.json'

export default function useProvinciasQuery() {
  const provincias = provinciasFile.provincias
  return provincias
}
